import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const expenses = (state = initialState.expenses, action) => {
  switch (action.type) {
    case types.LOAD_EXPENSE_SUCCESS:
      return action.expenses;

    case types.CREATE_EXPENSE_SUCCESS:
      return [...state, { ...action.expense }];

    case types.UPDATE_EXPENSE_SUCCESS:
      return [
        ...state.filter((exp) => exp.id !== action.expense._id),
        { ...action.expense }
      ];

    case types.DELETE_EXPENSE_SUCCESS:
      return [...state.filter((exp) => exp.id !== action.expenseId)];

    default:
      return state;
  }
};

export const savingExpense = (state = initialState.savingExpense, action) => {
  switch (action.type) {
    case types.SAVING_EXPENSE:
      return action.savingExpense;

    default:
      return state;
  }
};

export const expense = (state = initialState.expense, action) => {
  switch (action.type) {
    case types.GET_EXPENSE_SUCCESS:
      return action.expense;
    case types.UPDATE_EXPENSE_SUCCESS:
      return action.expense;
    default:
      return state;
  }
};

export const expenseToDelete = (
  state = initialState.expenseToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_EXPENSE_ID:
      return action.expenseToDelete;

    default:
      return state;
  }
};

export const expenseReceiptToDelete = (
  state = initialState.expenseReceiptToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_EXPENSE_RECEIPT_ID:
      return action.expenseReceiptToDelete;

    default:
      return state;
  }
};
